module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box-body form-center"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example2"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.giveCoupons.coupon_set_list), function(coupon, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v("\n          " + _vm._s(coupon.coupon_info.name) + "\n        ")]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-default",
      on: {
        "click": function($event) {
          return _vm.changeCur(coupon, index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-info"
    })])])])
  }), 0)])]), _vm._v(" "), (_vm.curCoupon.coupon_info) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('hr', {
    staticClass: "box-body form-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "box-body form-center"
  }, [_c('h4', [_vm._v(_vm._s(_vm.curCoupon.coupon_info.name))])]), _vm._v(" "), _c('div', {
    staticClass: "box-body form-left"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("優惠券名稱(前台)")]), _vm._v(" "), _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.curCoupon.coupon_info.name))])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("優惠券名稱(後台)")]), _vm._v(" "), _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.curCoupon.coupon_info.set_name))])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("優惠券說明(前台)")]), _vm._v(" "), _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.curCoupon.coupon_info.description))])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("優惠券說明(後台)")]), _vm._v(" "), _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.curCoupon.coupon_info.set_description))])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("優惠券備註(前台)")]), _vm._v(" "), _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.curCoupon.coupon_info.remark))])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("優惠券折扣金額")]), _vm._v(" "), _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.curCoupon.coupon_info.discount_value))])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("一次發送張數")]), _vm._v(" "), _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.curCoupon.amount_unit))])]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "box-body form-right"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("優惠券稅制")]), _vm._v(" "), (_vm.curCoupon.coupon_info.price_type) ? _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.curCoupon.coupon_info.price_type.label))]) : _vm._e()]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("優惠券類型")]), _vm._v(" "), (_vm.curCoupon.usage_store_config.usage_store_type) ? _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.curCoupon.usage_store_config.usage_store_type.label))]) : _vm._e()]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("適用門市方式")]), _vm._v(" "), (_vm.curCoupon.usage_store_config.usage_method) ? _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.curCoupon.usage_store_config.usage_method.label))]) : _vm._e()]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.curCoupon.usage_store_config.usage_method.value !== 'order_store'),
      expression: "curCoupon.usage_store_config.usage_method.value !== 'order_store'"
    }]
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("適用對象")]), _vm._v(" "), (_vm.curCoupon.usage_store_config.usage_store_value) ? _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.curCoupon.usage_store_config.usage_store_value.label))]) : _vm._e()]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.curCoupon.time_config.time_type) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("有效期間設定")]), _vm._v(" "), (_vm.curCoupon.time_config.time_type) ? _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.curCoupon.time_config.time_type.label))]) : _vm._e()]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.curCoupon.time_config.time_type.value === 'all_fixed') ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("開始時間")]), _vm._v(" "), _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.curCoupon.time_config.time.start.time))])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.curCoupon.time_config.time_type.value === 'day_day' || _vm.curCoupon.time_config.time_type.value === 'day_fixed') ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("拿到優惠券後幾天開始")]), _vm._v(" "), _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.curCoupon.time_config.use_start_day))])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.curCoupon.time_config.time_type.value === 'all_fixed' || _vm.curCoupon.time_config.time_type.value === 'day_fixed') ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("結束時間")]), _vm._v(" "), _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.curCoupon.time_config.time.end.time))])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.curCoupon.time_config.time_type.value === 'day_day') ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("開始後幾天結束")]), _vm._v(" "), _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.curCoupon.time_config.use_tolerance_day))])]), _vm._v(" "), _c('br')]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.curCoupon.usage_store_config.usage_method.value === 'manual' && _vm.curCoupon.usage_store_config.usage_store_type.value !== 3),
      expression: "curCoupon.usage_store_config.usage_method.value === 'manual' && curCoupon.usage_store_config.usage_store_type.value !== 3"
    }],
    staticClass: "box-body form-center"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, _vm._l((_vm.addStoresSetting.choose), function(store) {
    return _c('label', {
      staticClass: "label-primary label m-r-5"
    }, [_vm._v(_vm._s(_vm.getStoreName(store)))])
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('coupon-modal', {
    attrs: {
      "coupon": _vm.curCoupon
    }
  }), _vm._v(" "), _c('m-modal', {
    attrs: {
      "option": _vm.delOption
    },
    on: {
      "trigger": _vm.trigger
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("優惠券")]), _vm._v(" "), _c('th')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("優惠券可用店家")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-090eaef2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Marketing/Temp/CouponListInfo.vue
// module id = 2306
// module chunks = 1